/**
 * file模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const file = {
  //附件删除
  deleteAttatchment(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/file/delete`,param);
  },
  // 删除所有附件
  deleteByAttachmentIDs(params) {
    return $http.post(`${global.API_URL}/sme/file/deleteByAttachmentIDs`,params);
  },
  //附件下载
  downloadFile(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/file/downloadFile`,param,{
      responseType: 'arraybuffer'
    });
  }
}

export default file;



// WEBPACK FOOTER //
// ./src/api/file.js